module.exports = new __parcel__URL__("captain-toad-treasure-tracker.4ee46b85.jpg").toString();